<template>
    <ui-modal-message-v-2
        name='new-teams-modal'
        icon-square
        icon="fal fa-users-class"
        color-square="primary"
        dynamic-icon="fal fa-users-class"
        :cancel-button="true"
        @close-modal="handleCloseModal"
    >
        <template #title>
            <div class="title-container">
                <span class="first-title">Selecionar Equipes</span>
                <span class="second-title">Selecione as equipes que podem vender <b>{{ editUnit != null ? 'a unidade' : selectedUnitsChecked.length > 1 ? `as ${selectedUnitsChecked.length} unidades` : `a unidade` }}</b> {{ editUnit != null ? 'selecionada' : selectedUnitsChecked.length > 1 ? `selecionadas.` : 'selecionada.' }}</span>
            </div>
        </template>

        <template #text>
            <div class="text-container">
                <div class="container-teams">
                    <ui-input
                        placeholder="Buscar Equipe"
                        size="brb-off md"
                        container-design="mb-0"
                        design="brb-off"
                        v-model="searchQuery"
                    />

                    <div class="container-teams-scroll">
                        <div class="teams scroll-color-primary">
                            <div v-for="(team, index) in filteredTeams" :key="index" class="teams-checkbox">
                                <ui-checkbox
                                    design="xs"
                                    :label="team.name"
                                    :checked="team.checked"
                                    v-model="team.checked"
                                />
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </template>

        <template #footer>
            <div class="select-teams-quantity">
                <span class="quantity">{{ selectedTeamsCount > 1 ? 'Equipes selecionadas:' : 'Equipe selecionada:' }} <span>{{ selectedTeamsCount }}</span></span>
            </div>

            <ui-button
                design="md success"
                :disabled="enableButton && selectedTeamsCount > 0 || loadingButton"
                @click="handleAddTeamsForUnits"
            >
                <span v-if="loadingButton" class="loading-submit-user">
                    <ui-load-indicator bg-color="#fff" color="#41A870" :h="20" :stroke="6" />
                </span>

                Confirmar
            </ui-button>
        </template>
    </ui-modal-message-v-2>
</template>

<script>
import { uiLoadIndicator } from '@/components/ui';
import { uiButton } from '@/components/ui/buttons';
import { uiCheckbox, uiInput } from '@/components/ui/form';
import { uiModalMessageV2 } from '@/components/ui/modal';
import { alertMixin } from '@/mixins';
import { mapActions, mapGetters } from 'vuex';

export default {
    name: 'change-stage-status-modal',

    components: {
        uiModalMessageV2,
        uiButton,
        uiInput,
        uiCheckbox,
        uiLoadIndicator
    },

    props: {
        params: {
            type: Object,
            default: () => {}
        }
    },

    mixins: [
        alertMixin
    ],

    data(){
        return {
            teamsOptions: [],
            searchQuery: '',
            loadingButton: false,
            enableButton: false,
            editUnit: null
        }
    },

    mounted() {
        this.$root.$on('modal-msg-open-new-teams-modal', payload => {
            if (payload) {
                this.handleSelectedUnitsChecked(payload)

                this.editUnit = payload.id
            }

            const selectedTeamIds = new Set(payload?.teams?.map(team => team.id))

            this.teamsOptions = this.getData?.filters?.teams?.map(team => ({
                name: team.name,
                id: team.id,
                checked: selectedTeamIds?.has(team.id) || false
            })) || []

            this.teamsOptions.forEach((team, index) => {
                this.$set(this.teamsOptions, index, team)
            })
        })

    },

    beforeDestroy() {
        this.$root.$off('modal-msg-close-new-teams-modal')
    },

    computed: {
        ...mapGetters('exclusiveManagement', [
            'getData',
            'getSelectedUnitsChecked',
            'getConfigLimit'
        ]),

        selectedTeamsCount() {
            return this.teamsOptions.filter(team => team.checked).length
        },

        filteredTeams() {
            if (!this.searchQuery) return this.teamsOptions
            return this.teamsOptions.filter(team =>
                team.name.toLowerCase().includes(this.searchQuery.toLowerCase())
            )
        },

        selectedUnitsId() {
            return this.getSelectedUnitsChecked.map(unit => unit.id)
        },

        selectedUnitsChecked() {
            return this.getSelectedUnitsChecked
        },

        configLimitMsg() {
            return this.getConfigLimit?.msg
        },
    },

    methods: {
        ...mapActions('exclusiveManagement', [
            'activateExclusiveUnits',
            'handleSelectedUnitsChecked',
        ]),

        handleCloseModal() {
            this.teamsOptions = []
        },

        async handleAddTeamsForUnits() {
            this.loadingButton = true
            this.enableButton = true
            let selectTeamsId = this.teamsOptions.filter(team => team.checked).map(team => team.id)

            this.params.configurations.units = this.editUnit != null ? [this.editUnit] : this.selectedUnitsId
            this.params.configurations.teams = selectTeamsId
            this.params.configurations.has_view_units =  this.getData?.config?.has_view_units;
            this.params.configurations.has_view_value = this.getData?.config?.has_view_value;
            try {
                await this.activateExclusiveUnits(this.params)
                this.$mx_alertSuccess(this.configLimitMsg)
                this.handleCloseModal()

                if (this.editUnit != null) {
                    this.$root.$emit('select-all-disabled', false)
                    this.editUnit = null
                } else {
                    this.$root.$emit('select-all-disabled', true)
                }

                this.handleSelectedUnitsChecked([])
                this.$root.$emit('select-all-exclusive-units', false)
                this.$root.$emit('modal-msg-close-new-teams-modal')
            } catch (error) {
                if (error.data?.msg) {
                    this.$mx_alertError(error.data.msg)
                }
            } finally {
                this.loadingButton = false
                this.enableButton = false
            }
        },
    }
}
</script>

<style lang="stylus" scoped>
    @import './styles.styl';
</style>